import { VEHICLE_ID_PROP_NAME } from '../constants';
import injectParams from '../utils/injectParams';
import PropProvider from '../PropProvider';
import { breadcrumbsConnectDefaults } from '../utils/ConnectDefaults';
import AssetMetrics from '../components/AssetMetrics';

export default injectParams(breadcrumbsConnectDefaults(
  AssetMetrics,
  (state, ownProps) => PropProvider(state).AssetMetrics(ownProps[VEHICLE_ID_PROP_NAME]),
  'au.section.title.vehicles',
  'details'
));
